// 参考
// https://github.com/gatsbyjs/gatsby/issues/1847#issuecomment-372761930
exports.onClientEntry = () => {
  require('babel-polyfill')
}
// https://littlebylittle.work/2020/01/gatsby-syntax-highlighting/
require("prismjs/themes/prism-okaidia.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
